// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSListDetailContainer/index.less
// module id = 1146
// module chunks = 42